var $2d5eecd634a9ca45$exports = {};
$2d5eecd634a9ca45$exports = {
  "rangeOverflow": function rangeOverflow(args) {
    return "Hodnota mus\xED b\xFDt ".concat(args.maxValue, " nebo d\u0159\xEDv\u011Bj\u0161\xED.");
  },
  "rangeReversed": "Datum zah\xE1jen\xED mus\xED p\u0159edch\xE1zet datu ukon\u010Den\xED.",
  "rangeUnderflow": function rangeUnderflow(args) {
    return "Hodnota mus\xED b\xFDt ".concat(args.minValue, " nebo pozd\u011Bj\u0161\xED.");
  },
  "unavailableDate": "Vybran\xE9 datum nen\xED k dispozici."
};
export { $2d5eecd634a9ca45$exports as default };